// Menu level
export enum MenuId {
    AboutUs = 'about-us',
    Services = 'services',
    Publications = 'publications',
    InvestorRelations = 'investor-relations',
    Sustainability = 'sustainability',
    Faq = 'frequently-asked-questions',
    Career = 'career',
    SiteMap = 'site-map',
    PartnerInformation = 'partner-information',
    ContactUs = 'contact-us',
    ProcurementInformation = 'procurement-information',
  }
  
  // Section level
  export enum SectionId {
    Ecosystem = 'ekosistem-pembiayaan-perumahan',
    CompanyProfile = 'company-profile',
    Management = 'management',
    Committees = 'committees',
    CorporateActions = 'corporate-actions',
    Certifications = 'certifications-awards',
    Governance = 'governance',
    CorporateSecretary = 'corporate-secretary',
    Affiliations = 'affiliations',
    Securitization = 'securitization',
    RetailEba = 'retail-eba',
    ShariaUnit = 'sharia-unit',
    Financing = 'financing',
    Bonds = 'bonds',
    MortgageStandardization = 'mortgage-standardization',
    Training = 'training',
    NewsActivities = 'news-activities',
    Biweekly = 'biweekly-economic-and-market-update',
    Emagazine = 'emagazine',
    FinancialReports = 'financial-reports',
    AnnualReports = 'annual-reports',
    EbaSpPerformance = 'eba-sp-performance',
    SocialBonds = 'social-bond-and-sukuk-report',
    InvestmentProducts = 'investment-products',
    DividendInfo = 'dividend-info',
    ImportantInfo = 'important-info',
    CorporateRatings = 'corporate-ratings',
    CorporateSocialResponsibilities = 'corporate-social-responsibilities',
    SustainabilityReport = 'sustainability-report',
    ProcurementInformation = 'procurement-information',
    GeneralNotification = 'general-notification',
  }
  
  // Item level
  export enum ItemId {
    Commissioners = 'commissioners',
    Directors = 'directors',
    ShariaSupervisoryBoard = 'sharia-supervisory-board',
    Policies = 'policies',
    TrainingSchedule = 'training-schedule',
    AssetInvestments = 'asset-investments',
    BondInvestments = 'bond-investments',
    SocialBondInvestments = 'social-bond-investments',
    InvestorUpdate = 'investor-update',
    PublicAnnouncement = 'public-offering-announcement',
    AnnualFinancialReport = 'annual-financial-report',
    InterimFinancialReport = 'interim-financial-report',
    ListOfPlannedProcurement = 'list-of-planned-procurement',
    TenderInformation = 'tender-information',
  }